<mat-card *ngIf="exerciceRow"
          class="exercice-card"
          appearance="outlined"
          (click)="onShowClicked.emit(exerciceRow)"
          [ngStyle]="{'cursor': exerciceRow.rights?.view ? 'pointer' : 'default'}">
  <mat-card-header class="mat-header">
    <img *ngIf="exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path" [alt]="exerciceRow.exercice.name"
         ngSrc="{{ conf.storageRootUrl + (exerciceRow.exercice.image || exerciceRow.exercice.video_thumbnail_path) }}" fill>
    <div class="video-overlay" *ngIf="exerciceRow.exercice.video_path">
      <mat-icon class="play-icon">play_circle_filled</mat-icon>
    </div>
    <mat-icon *ngIf="!(exerciceRow.exercice?.image || exerciceRow.exercice?.video_thumbnail_path)">
      image
    </mat-icon>
  </mat-card-header>
  <mat-card-content class="card-content">
    <mat-card-title>
      <div class="title-container">
        {{ exerciceRow.exercice.name }}
        <div>
          <button *ngIf="exerciceRow.rights?.duplicate || exerciceRow.rights?.edit || exerciceRow.rights?.delete"
                  mat-icon-button
                  [matMenuTriggerFor]="rowMoreMenu"
                  (click)="onVerticalMenuClicked($event)">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #rowMoreMenu="matMenu" xPosition="before">
            <button mat-menu-item
                    *ngIf="exerciceRow.rights?.duplicate"
                    (click)="onDuplicateExerciceClicked.emit(exerciceRow)">
              <mat-icon>filter_none</mat-icon>&nbsp;{{ 'Duplicate' | translate }}
            </button>
            <button mat-menu-item
                    *ngIf="exerciceRow.rights?.edit"
                    (click)="onModifyExerciceClicked.emit(exerciceRow)">
              <mat-icon>edit_outlined</mat-icon>&nbsp;{{ 'Edit' | translate }}
            </button>
            <button mat-menu-item
                    *ngIf="exerciceRow.rights?.delete"
                    (click)="onDeleteExerciceClicked.emit(exerciceRow)">
              <mat-icon>delete_outlined</mat-icon>&nbsp;{{ 'Delete' | translate }}
            </button>
          </mat-menu>
        </div>
      </div>
    </mat-card-title>
    <mat-card-subtitle>
      <div class="accents-container">
        <div *ngFor="let category of exerciceRow.categories">
          <exercice-category-thumbnail *ngIf="category" [hideText]="true" [data]="category" />
          {{ category?.name }}
        </div>
      </div>
    </mat-card-subtitle>
    <div class="tags-container">
      {{ exerciceRow.exercice?.tags }}
    </div>
    <p class="transcode-text" *ngIf="isVideoBeingTranscoded()">{{ 'video_is_transcondig'|translate }}</p>
    <div class="separator"></div>
    <div class="author-container">{{'Created_by' | translate }} {{ (exerciceRow.creater?.firstName ?? '') + ' ' + (exerciceRow.creater?.lastName ?? '') }}</div>
  </mat-card-content>
</mat-card>
